import React from 'react';
import Select from 'react-select';

const SelectCardPriceRank = props => {
  const options = [
    { value: null, label: 'Todos' },
    { value: 4, label: 'Baratos' },
    { value: 3, label: 'En precio' },
    { value: 2, label: 'Caros' },
    { value: 1, label: 'Sin referencia de precio' },
  ];

  const onChangeWrapper = value => {
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-nameless';
    event.target.value = value.value;
    event.target.type = 'react-select';
    props.onChange(event);
  };

  let value = props.value;

  if (value) {
    value = options.find(option => option.value === value);
  }

  return (
    <Select
      className={props.selectClassName}
      name={props.name}
      onChange={onChangeWrapper.bind(this)}
      value={value || ''}
      required={props.required}
      options={options}
      clearable={false}
      placeholder={props.placeholder}
      menuContainerStyle={{ zIndex: 999 }}
      menuPortalTarget={document.body} // Moves the menu to the body element, outside of the component flow
      disabled={props.disabled}
      styles={{
        control: provided => ({
          ...provided,
          height: '40px', // Ensure control is 40px
          minHeight: '40px', // Ensure no shrinking below 40px
          padding: '0 0px', // Adjust horizontal padding if needed
          borderRadius: '0.375rem', // Tailwind's rounded-md corresponds to 0.375rem
        }),
        dropdownIndicator: provided => ({
          ...provided,
          padding: '0 8px', // Adjust padding for dropdown indicator
        }),
        clearIndicator: provided => ({
          ...provided,
          padding: '0 8px', // Adjust padding for clear indicator
        }),
        input: provided => ({
          ...provided,
          padding: '0', // Ensure no extra padding that would reduce height
          margin: '0', // Remove margin to keep the height consistent
        }),
        singleValue: provided => ({
          ...provided,
          margin: '0', // Remove margin for the selected value text
        }),
      }}
    />
  );
};

export default SelectCardPriceRank;
